module.exports = __webpack_public_path__ + "static/media/test-tube.e51c5b37.svg";